<template>
    <v-dialog v-model="dialog" width="1200" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-textarea
                                v-model="concerns" 
                                label="Concerns/Issues" 
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen">
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-textarea 
                                v-model="institutes" 
                                label="Institutes" 
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen">
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-textarea 
                                v-model="recommendations" 
                                label="Recommendations/Actions" 
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen">
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-textarea 
                                v-model="agreement" 
                                label="Compliance/Agreement"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen">
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-textarea 
                                v-model="date_complied" 
                                label="Date Complied" 
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen">
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-textarea 
                                v-model="remarks" 
                                label="Remarks" 
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen">
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            compliance_matrix_id: null,
            concerns: null,
            institutes: null,
            recommendations: null,
            agreement: null,
            date_complied: null,
            remarks: null,
        }
     },
     methods: {
        initAdd(data){
            this.dialog = true
            this.dialog_title = 'Recommendation and Compliance Matrix Details'
            this.dialog_sub_title = 'Add AMS Form 1 details information'
            this.action = 'add'

            this.compliance_matrix_id = data.id
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Update Recommendation and Compliance Matrix Details'
            this.dialog_sub_title = data.concerns
            this.action = 'edit'

            this.id = data.id
            this.compliance_matrix_id = data.compliance_matrix_id
            this.concerns = data.concerns
            this.institutes = data.institutes
            this.recommendations = data.recommendations
            this.agreement = data.agreement
            this.date_complied = data.date_complied
            this.remarks = data.remarks
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.id,
                    compliance_matrix_id: this.compliance_matrix_id,
                    concerns: this.concerns,
                    institutes: this.institutes,
                    recommendations: this.recommendations,
                    agreement: this.agreement,
                    date_complied: this.date_complied,
                    remarks: this.remarks,
                }

                if(this.action == 'add'){
                    let res = await this.axiosCall('/compliance-matrix-details', 'post', formData, true)
                    if(res.data.status == 200){
                        this.loading = false
                        this.$emit('refresh')
                        showSnackbar('Compliance Matrix Details successfully added!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }
                else if(this.action == 'edit'){
                    let res = await this.axiosCall('/compliance-matrix-details/' + this.id, 'patch', formData, true)
                    if(res.data.status == 200){
                        this.loading = false
                        this.$emit('refresh')
                        showSnackbar('Compliance Matrix Details successfully updated!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.$emit('refresh')
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>